import { Component } from '@angular/core';
import { Router } from '@angular/router';
import Auth from '@aws-amplify/auth';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { State } from './reducers';
import { clearAssessment } from './store/assessment/assessment.actions';
import { authenticateUserPrecheck, authLogout } from './store/auth/auth.actions';
import { User } from './store/auth/auth.models';
import { clearGoals } from './store/goal/goal.actions';
import { ClearResumes } from './store/resume/resume.actions';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  title = 'gtap';
  authenticatedUser: Observable<User>;

  constructor(private store: Store<State>, private router: Router) {
    this.store.dispatch(authenticateUserPrecheck());
    this.authenticatedUser = this.store.select(state => state.auth.authenticatedUser);
  }

  logout(): void {
    this.store.dispatch(authLogout());
    this.store.dispatch(clearAssessment());
    this.store.dispatch(clearGoals());
    this.store.dispatch(ClearResumes());
    Auth.signOut().then(() => {
      this.router.navigate(['/auth/login']);
      this.store.dispatch(authenticateUserPrecheck());
    })
  }
}
